module.exports = "<ngx-bootstrap-product-tour></ngx-bootstrap-product-tour>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main